// Modo embutido (iframe do "Ajuda" nos painéis app.*.com.br): as mesmas telas da central, sob
// /embed. Toda navegação interna passa por rota() para não sair do modo embutido.
export const PREFIXO_EMBUTIDO = "/embed";

export const estaEmbutido = () => window.location.pathname.startsWith(PREFIXO_EMBUTIDO);

export const rota = (caminho: string) => (estaEmbutido() ? PREFIXO_EMBUTIDO : "") + caminho;

// Site que está embutindo a central (o painel do "Ajuda"). ancestorOrigins é preenchido pelo
// navegador (o site de fora não consegue falsificar); o Firefox não tem, e aí vale o referrer,
// que o painel manda por padrão. Fora de iframe, ou sem nenhum dos dois, devolve null.
export const origemDoSiteDeFora = (): string | null => {
  if (window.parent === window) return null;
  const ancestrais = window.location.ancestorOrigins;
  if (ancestrais && ancestrais.length) return ancestrais[0];
  try {
    return document.referrer ? new URL(document.referrer).origin : null;
  } catch {
    return null;
  }
};
